/**
 * Created by Raul.
 *
 * Agregar las rutas que se desean cargar, usando la carga asincrona, se deben aregar por modulo
 *
 *  @routesApp Arreglo de rutas de la aplicación.
 */
import {Routes} from '@angular/router';
import {AuthGuardAdmin} from './common.module/auth/auth-guard.admin.service';
import {AuthGuardInbox} from './common.module/auth/auth-guard.inbox';

const routesApp: Routes = [

  {
    path: '',
    loadChildren: './portal.index.module/index.module#IndexModule',
  },
  {
    path: 'bandeja_entrada',
    loadChildren: './portal.formalities.module/portal-formalities.module#CitizenFormalityModule',
    canActivate: [AuthGuardAdmin]
  },
  // {
  //   path: 'reporte-ciudadano',
  //   loadChildren: './portal.reporte-ciudadano.module/portal-ciudadano.module#PortalCiudadanoModule',
  // },
  {
    path: 'agenda',
    loadChildren: './portal.agenda.module/portal-agenda.module#PortalAgendaModule',
    // canActivate: [AuthGuardAdmin]
  },
  {
    path: 'bpm_tramites',
    loadChildren: './portal.bpm.module/bpm.module#BpmModule',
    canActivate: [AuthGuardInbox]
  },
  {
    path: 'noticias',
    loadChildren: './portal.noticias.module/noticias.module#NoticiasModule'
  }
];
export const PortalRoutesModules = [...routesApp];
